import { Numeric4CircleOutlineIcon } from './Numeric4CircleOutlineIcon';

/**
 * author: Contributors
 * id 898E368A-092D-45E4-B84D-9C99ABFFF2AC
 * name numeric-4-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-4-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumericFourCircleOutlineIcon = Numeric4CircleOutlineIcon;
export default NumericFourCircleOutlineIcon